import React, { useState, useEffect } from 'react'
import { DangerouslySetHtmlContent } from '../helpers';

import SEO from '../components/Seo';
import Header from '../components/Header'
import PreFooter from '../components/PreFooter'
import Footer from '../components/Footer'

const BasicPage = ({ pageContext, data }) => {
  const { page } = pageContext
  const [isApp, setIsApp] = useState(false);

  useEffect(() => {
    if (window && window.location) {
      let search = window.location.search
      setIsApp(search && search === '?app=true' ? true : false)
    }
  }, [])

  return (
    <>
      <SEO
        title={page.title}
        description={page.searchDescription || ''}
        // image={page.video.thumbnail}
        pathname={page.slug}
        isApp={isApp}
      />

      {!isApp &&
        <Header></Header>
      }

      <div className="px-8 md:px-12 lg:px-20 2xl:px-32">
        <div className="mx-auto max-w-screen-md py-16 md:py-24">
          <h1 style={{ fontSize: 'var(--font-size-xxxl)' }} className="textstroke mb-12 font-title uppercase duration-300 leading-[1]">
            {page.title}
          </h1>
          {page.id == 75 &&
            <div className='bg-white rounded-3xl overflow-hidden p-2 my-6'>
              <iframe src="https://api.kelowna10.com/page/75/htmlembed/" width="100%" height="550px" />
            </div>
          }
          <DangerouslySetHtmlContent
            className="prose md:prose-xl text-chalk-200 prose-headings:font-title prose-headings:uppercase prose-headings:leading-[1] prose-headings:text-chalk-100"
            html={page.content}
          />
          {page.id == 8 &&
            <div className='bg-white rounded-3xl overflow-hidden p-2 my-6'>
              <div className="hidden md:block" style={{ height: '965px' }}>
                <iframe
                  width="100%"
                  height="100%"
                  id="JotFormIFrame-213045183694053"
                  title="Contact Us"
                  onload="window.parent.scrollTo(0,0)"
                  allowtransparency="true"
                  allowfullscreen="true"
                  allow="geolocation; microphone; camera"
                  src="https://form.jotform.com/213045183694053"
                  frameBorder="0"
                />
              </div>
              <div className="md:hidden" style={{ height: '830px' }}>
                <iframe
                  width="100%"
                  height="100%"
                  id="JotFormIFrame-213045183694053"
                  title="Contact Us"
                  onload="window.parent.scrollTo(0,0)"
                  allowtransparency="true"
                  allowfullscreen="true"
                  allow="geolocation; microphone; camera"
                  src="https://form.jotform.com/213045183694053"
                  frameBorder="0"
                />
              </div>
            </div>
          }
        </div>
      </div>

      {!isApp &&
        <>
          <PreFooter></PreFooter>
          <Footer></Footer>
        </>
      }
    </>
  )
}

export default BasicPage
